'use strict';
import isString from 'lodash/isString';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';

export function LinkView(props) {
  const classProps = {};
  const hasActivatedClassName = isString(props.activatedClassName);
  const hasActiveClassName = isString(props.activeClassName);

  if (hasActiveClassName) {
    classProps[props.activeClassName] = props.isActive;
  }

  if (hasActivatedClassName
    && hasActiveClassName
    && props.activatedClassName === LinkView.defaultProps.activatedClassName
  ) {
    classProps[`${props.activatedClassName} ${props.activeClassName}`] = props.isActivated;
  } else if (hasActivatedClassName) {
    classProps[props.activatedClassName] = props.isActivated;
  }

  return (
    <div
      title={props.title}
      className={classNames('', props.className, classProps)}
      onClick={props.onClick}
    >
      {props.children}
    </div>
  );
}

LinkView.propTypes = {
  className: T.string,
  activeClassName: T.string,
  activatedClassName: T.string,

  isActive: T.bool,
};

LinkView.defaultProps = {
  activatedClassName: 'Link_activated',
};



// WEBPACK FOOTER //
// ./src/js/app/components/Link/LinkView.js